import { render, staticRenderFns } from "./UserArticleList.vue?vue&type=template&id=23b8a765&scoped=true&"
import script from "./UserArticleList.vue?vue&type=script&lang=js&"
export * from "./UserArticleList.vue?vue&type=script&lang=js&"
import style0 from "./UserArticleList.vue?vue&type=style&index=0&id=23b8a765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8a765",
  null
  
)

export default component.exports